import { render, staticRenderFns } from "./gak-global.kr.vue?vue&type=template&id=4fe3ddde&"
import script from "./gak-global.kr.vue?vue&type=script&lang=js&"
export * from "./gak-global.kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports